export const Wrapper = 'font-Roboto text-14 flex w-full flex-col text-black'
